export default {
  en: {
    distance: "distance",
    gain: "gain",
    loss: "loss",
    high: "high",
    low: "low",
    mi: "miles",
    km: "km",
    ft: "ft",
    m: "m"
  }
}
